import React from 'react';

const fullAdUrl = (path) => {
    if (!path) return null;
    return path.startsWith('http') ? path : `https://fantasyworldtrpg.cz${path}`;
};

const AdBanner = ({ ad }) => {
    if (!ad) return null;

    return (
        <a href={ad.url} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'inherit'}}>
            <div className="my-4 p-3 bg-danger-subtle border rounded shadow-sm text-center">
                <img loading="lazy" src={fullAdUrl(ad.image)} alt={ad.title}
                     style={{maxHeight: 200, objectFit: 'cover', maxWidth: '100%'}} className="mb-2 rounded"/>
                <h6 className="mt-2">{ad.title}</h6>
            </div>
        </a>
)
    ;
};

export default AdBanner;
